export const UPDATE_TASK = 'update_task';
export const UPDATE_TASK_SUCCESSFUL = 'update_task_successfull';
export const UPDATE_TASK_FAILED = 'update_task_failed';



